import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Pipe({
  name: 'msConverter'
})
export class MsConverterPipe implements PipeTransform {

  constructor(private translate: TranslateService) {

  }

  transform(value: number, lang: string) {

    if (!value) return '0 s';

    const days = Math.floor(value / (1000 * 60 * 60 * 24));
    const hours = Math.floor((value % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((value % (1000 * 60)) / 1000);
    let result = '';

    if (lang == "es") {
      if (days > 0) {
        return `Hace ${days} `+ (days == 1 ? `dia` : `días`);
      }
  
      if (hours > 0) {
        return`Hace ${hours} `+ (hours == 1 ? `hora` : `horas`);
      }

      if (minutes > 0) {
        return `Hace ${minutes} ` + (minutes == 1 ? `minuto` : `minutos`);
      }

      if (seconds > 0 || (!hours && !minutes)) {
        return `Hace ${seconds} `+ (seconds == 1 ? `segundo` : `segundos`);
      }

      return ""
    }
    
    if (days > 0) {
      return `${days} ` + (days == 1 ? `day` : `days`) + ` ago`;
    }

    if (hours > 0) {
      return `${hours} ` + (hours == 1 ? `hour` : `hours`) + ` ago`;
    }
    if (minutes > 0) {
      return `${minutes} ` + (minutes == 1 ? `minute` : `minutes`) + ` ago`;
    }
    if (seconds > 0 || (!hours && !minutes)) {
      return `${seconds} ` + (seconds == 1 ? `second` : `seconds`) + ` ago`;
    }
    return ""
  }
}
